<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPlayRound_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m2.05-6.567a.5.5 0 0 0 0-.866l-2.7-1.559a.5.5 0 0 0-.75.433V9.56a.5.5 0 0 0 .75.433z"
        clip-rule="evenodd"
    />
</svg>
